import React from 'react';

const MountainIcon = (props) => {
  return (
    <img
      alt="Góra"
      src="/static/images/icons/place_types/mountain.svg"
      {...props}
    />
  );
};

export default MountainIcon;
